
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1692"}},[_c('path',{attrs:{"data-name":"Rectangle 2401","fill":"none","d":"M0 0h25v20H0z"}}),_c('path',{attrs:{"data-name":"Union 19","d":"M13.745 19.913a1.158 1.158 0 01-.826-1.056V5.42a1.073 1.073 0 01.392-.808A11.264 11.264 0 0120.667 2a1.251 1.251 0 011.334 1.145V16.58a1.251 1.251 0 01-1.334 1.144 8.373 8.373 0 00-5.467 1.941 1.457 1.457 0 01-.945.335 1.507 1.507 0 01-.51-.087zm-3.946-.247a8.365 8.365 0 00-5.466-1.941 1.25 1.25 0 01-1.334-1.144V3.145A1.251 1.251 0 014.333 2a11.259 11.259 0 017.354 2.612 1.068 1.068 0 01.392.808v13.437a1.159 1.159 0 01-.825 1.056 1.512 1.512 0 01-.509.087 1.461 1.461 0 01-.945-.335z","fill":"#3c3c3c"}})])])
          )
        }
      }
    